import React from 'react'
import { Edit, useTranslate } from 'react-admin'

import WithContentForm from 'components/withContentForm'

import Form from './components/form'

const Title = ({ record }) => {
	const t = useTranslate()
	return <>{record ? t('resources.Facility.edit', { name: record.name }) : t('resources.Facility.name')}</>
}

const FacilityEdit = props => (
	<Edit title={<Title />} undoable={false} {...props}>
		<WithContentForm>
			<Form />
		</WithContentForm>
	</Edit>
)

export default FacilityEdit
